import { DOCUMENT_COMPONENT_TYPES } from "../constants/document";

import { IMAGE_URLS } from "../constants";

const {
  blockEspace,
  blockGSheet,
  blockImage,
  blockPBreak,
  blockQTable,
  blockSign,
  blockStripe,
  blockTable,
  blockText,
  blockPageNumber,
} = IMAGE_URLS;

const getDragImage = type => {
  switch (type) {
    case DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET:
      return blockGSheet;
    case DOCUMENT_COMPONENT_TYPES.IMAGE:
      return blockImage;
    case DOCUMENT_COMPONENT_TYPES.PAGE_BREAK:
      return blockPBreak;
    case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE:
    case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER:
      return blockQTable;
    case DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER:
      return blockSign;
    case DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON:
      return blockStripe;
    case DOCUMENT_COMPONENT_TYPES.TABLE:
      return blockTable;
    case DOCUMENT_COMPONENT_TYPES.HTML:
      return blockText;
    case DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER:
    case DOCUMENT_COMPONENT_TYPES.LINE_SPACE:
      return blockEspace;
    case DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER:
      return blockPageNumber;
    case DOCUMENT_COMPONENT_TYPES.SIGNATURE_TEXT:
      return blockSign;
    case DOCUMENT_COMPONENT_TYPES.SIGNATURE_CHECKBOX:
      return blockSign;
    default:
      return null;
  }
};
export default getDragImage;
